'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalogDetail = require('./mock/catalogDetail');

var _catalogDetail2 = require('./remote/catalogDetail');

var CatalogDetail = {
    fetchCatalogDetailsByIds: function fetchCatalogDetailsByIds(params) {
        return __MOCK__ ? _catalogDetail.CatalogDetailMock.fetchCatalogDetailsByIds(params) : _catalogDetail2.CatalogDetailRemote.fetchCatalogDetailsByIds(params);
    }
};

exports.default = CatalogDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalogDetail.js
// module id = Kt20
// module chunks = 57